import {nothingSelector} from 'services/utils/selectors/nothingSelector';
import {useAppSelector} from 'store/hooks';
import type {ManifestationV4} from '../types';
import {selectMetadataEditMetadataManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';

export const useConditionalManifestationEdit = (
  manifestationId: string,
  required: boolean,
): ManifestationV4 | undefined => {
  const selector = useCreateSelectorById(
    manifestationId,
    selectMetadataEditMetadataManifestationById,
  );
  return useAppSelector(required ? selector : nothingSelector);
};
